import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import residentsIcn from 'assets/img/icon-dash-residents.svg';
// import nonResidents from 'assets/img/icon-dash-non-resident.svg';
// import transactionsIcn from 'assets/img/icon-dash-transactions.svg';
// import registrants from 'assets/img/icon-dash-registrants.svg';
import * as c from '../constants';
import * as actions from '../actions';

import MiniLoader from '../../common/components/MiniLoader';
import CmsContext from '../../../context/CmsContext';

function StatsComponent({ getCounts, counts }) {
  const cmsContext = useContext(CmsContext);
  const { transactions_human, tax_payers, residents, non_residents } = counts;
  const CMS_ICONS = cmsContext.findByType('ICONS');

  const cmsIcons = {
    registrants: _.get(CMS_ICONS, 'CORE_REGISTRANT.cdnUrl'),
    transactionsIcn: _.get(CMS_ICONS, 'CORE_TRANSACTION.cdnUrl'),
    residentsIcn: _.get(CMS_ICONS, 'CORE_RESIDENTS.cdnUrl'),
    nonResidents: _.get(CMS_ICONS, 'CORE_NON_RESIDENTS.cdnUrl'),
  };

  useEffect(() => {
    getCounts();
  }, []);

  return (
    <div className="stats-container row">
      <div className="stats-item col-md-3">
        <div className="stats-item-inner">
          <div className="stats-item-title">Registrants</div>
          <div className="stats-item-no-wrapper">
            <div className="stats-item-icon">
              {!_.isEmpty(CMS_ICONS) ? (
                <img src={cmsIcons.registrants} alt="" />
              ) : (
                <MiniLoader />
              )}
            </div>
            <div className="stats-item-numbers">
              {_.get(tax_payers, 'count')
                ? _.get(tax_payers, 'count').toLocaleString()
                : 0}
            </div>
          </div>
        </div>
      </div>
      <div className="stats-item col-md-3">
        <div className="stats-item-inner">
          <div className="stats-item-title">Finished Transactions</div>
          <div className="stats-item-no-wrapper">
            <div className="stats-item-icon">
              {!_.isEmpty(CMS_ICONS) ? (
                <img src={cmsIcons.transactionsIcn} alt="" />
              ) : (
                <MiniLoader />
              )}
            </div>
            <div className="stats-item-numbers">
              {transactions_human ? transactions_human.toLocaleString() : 0}
            </div>
          </div>
        </div>
      </div>
      <div className="stats-item col-md-3">
        <div className="stats-item-inner">
          <div className="stats-item-title">Residents</div>
          <div className="stats-item-no-wrapper">
            <div className="stats-item-icon">
              {!_.isEmpty(CMS_ICONS) ? (
                <img src={cmsIcons.residentsIcn} alt="" />
              ) : (
                <MiniLoader />
              )}
            </div>
            <div className="stats-item-numbers">
              {_.get(residents, 'count')
                ? _.get(residents, 'count').toLocaleString()
                : 0}
            </div>
          </div>
        </div>
      </div>
      <div className="stats-item col-md-3">
        <div className="stats-item-inner">
          <div className="stats-item-title">Non-Residents</div>
          <div className="stats-item-no-wrapper">
            <div className="stats-item-icon">
              {!_.isEmpty(CMS_ICONS) ? (
                <img src={cmsIcons.nonResidents} alt="" />
              ) : (
                <MiniLoader />
              )}
            </div>
            <div className="stats-item-numbers">
              {_.get(non_residents, 'count')
                ? _.get(non_residents, 'count').toLocaleString()
                : 0}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

StatsComponent.defaultProps = {
  counts: {},
};

StatsComponent.propTypes = {
  getCounts: PropTypes.instanceOf(Function).isRequired,
  counts: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  counts: _.get(api, `${c.GET_COUNTS}.res`),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(StatsComponent);
